import swal from 'sweetalert2'
import axios from 'axios'
import Vue from 'vue'

import {
  randomString,
} from '../plugins/helper'

const HelperFile = {
  data: () => ({
    archivesImages: [],
    miscellaneousFiles: [],
    extImg: ['jpeg', 'jpg', 'png'],
  }),
  mounted: function () {
    this.$nextTick(async function () {
      if (this.checkVariable(this.modelId, this.reference)) {
        const { data } = await this.getFiles(this.modelId, this.reference)
        this.passFiles(data)
      }
    })
  },
  methods: {
    /**
     * @param {Number} id
     * @param {String} reference
     * @return {Promise|Array}
     */
    async getFiles(id, reference) {
      if (this.determinesInspectionAction(['getGroupedFiles'])) {
        return axios.get(`/api/files/grouped_files/${id}/${reference}`)
      }

      return []
    },
    /**
     * @param {Array} data
     */
    passFiles(data) {
      if ((this.isArray(data) || this.isObject(data)) && (this.getAmountOfKeys(data) > 0)) {
        const files = []
        const miscellaneousFiles = []
        Object.keys(data).forEach(ext => {
          if (this.extImg.indexOf(ext) !== -1) {
            files.push(data[ext])
          } else {
            miscellaneousFiles.push(data[ext])
          }
        })
        this.miscellaneousFiles = this.flatten(miscellaneousFiles)
        this.archivesImages = this.flatten(files)
      }
    },
    /**
     * @param {String} url
     * @param {Number|null} id
     * @param {String|null} revertAction
     * @param {String|null} alternativeUrl
     * @param {String|null} otherText
     * @return {Promise}
     */
    actionDeleteFile(url, id = null, revertAction = null, alternativeUrl = null, otherText = null) {
      this.swalToast = false
      this.swalIcon = 'warning'
      this.swalTimer = undefined
      this.swalPosition = 'center'
      this.swalTimerProgressBar = false
      this.swalShowConfirmButton = true

      const other = this.checkVariable(otherText) ? otherText : ''
      const toast = this.setupSwal()

      return toast.fire({
        title: swal.i18n.t('confirmar'),
        text: `${swal.i18n.t('warning_text')}${other}`,
        confirmButtonText: swal.i18n.t('delete_text'),
        preConfirm: () => {
          if (this.checkVariable(revertAction) && this.checkVariable(alternativeUrl)) {
            const data = this.checkVariable(id) ? [{ id }] : []
            this.captureDataToRevert(revertAction, data, 'Se eliminó el registro.', alternativeUrl)
          }

          return axios.delete(url, { params: { id } })
        },
      })
    },
    /**
     * @param {Promise} promise
     * @param {Boolean} canBeReverted
     */
    actionDeleteThen(promise, canBeReverted = true) {
      const self = this
      promise.then(
        async result => {
          const { value } = result
          if (this.checkVariable(value) && this.checkVariable(value.status) && value.status === 200) {
            self.swalToast = true
            self.swalTimer = 3000
            self.swalIcon = 'success'
            self.swalPosition = 'center-end'
            self.swalTimerProgressBar = false
            self.swalShowConfirmButton = false
            self.swalText = swal.i18n.t('deleted_result')
            self.swalTitle = swal.i18n.t('deleted_title')
            self.positionedDialogToast()

            if (canBeReverted) {
              this.$root.$emit('triggerSwitchRevertDataToast', true)
            }

            await self.$store.dispatch('deleteModel', result)
          }
        },
        function (dismiss) {
          console.log(dismiss)
        },
      ).catch(err => console.log(err))
    },
    randomString(length) {
      return randomString(length)
    },
    /**
     * @param {Array} services
     * @return {Array}
     */
    transformTablesFiles(services) {
      const files = []
      if (this.isArray(services)) {
        services.forEach(service => {
          if (this.checkVariable(service.files) && this.getAmountOfKeys(service.files) > 0) {
            service.files.forEach(file => {
              files.push({
                id: file.id,
                created_at: file.created_at,
                numero: service.numero_factura,
                nombre_original: file.nombre_original,
              })
            })
          }
        })
      }

      return files
    },
    /**
     * @param {mixed} fileAttributes
     */
    assignIfInstantDescription(fileAttributes) {
      let description = ''
      if (fileAttributes && fileAttributes.hasOwnProperty('instant_description')) {
        description = fileAttributes.instant_description
      }

      return description
    },
    assignIndexIfInstantDescription(increments, fileAttributes, index) {
      if (fileAttributes && fileAttributes.hasOwnProperty('instant_description')) {
        return index + increments
      }

      return index + 1
    },
    assignPosition(fileAttributes) {
      let position = null
      if (fileAttributes && fileAttributes.hasOwnProperty('position')) {
        position = fileAttributes.position
      }

      return position
    },
    captureRecordDataForRevert(id) {
      const request = {
        action: 'delete',
        data: [
          { id },
        ],
      }

      const object = {
        request,
        message: 'Se eliminó el registro.',
      }

      this.$store.dispatch('captureRecordData', object)
    },
  },
  destroyed: function () {
    this.archivesImages = []
    this.miscellaneousFiles = []
  },
}

const Component = Vue.extend({
  name: 'helper-file-jimp',
  mixins: [HelperFile],
})

export default Component
